import StoreSubscriptionService from "@/framework/services/store/storeSubscriptionService";

/**
 * A vuex plugin to handle the KtznEventSubscription related events
 * that are published through the Vuex store via actions or mutations.
 *
 * Creates a global instance of the StoreSubscriptionService
 * when the app is initially started (see the store file: `src/store/index.ts`).
 * It is possible to listen to any other vuex subscripton action or mutation in here.
 *
 * With this setup the websocket connection can also be started or stopped
 * by using the vuex store mutations and actions.
 *
 * @returns A closure with the update Store including
 * the added store subscription handlers (e.g. mutation and action listeners).
 */
export default function ktznEventStoreSubscription() {
  return (store: any) => {
    // Create a store subscription service instance
    const service = StoreSubscriptionService;

    // Subscribes to the vuex actions and stores the subscriptions in a variable
    const unsubscribeActions = store.subscribeAction(async (action: any, state: any) => {
      const res = await service.handleSubscribeAction(action, state);
      // if (res && res.isErr()) console.log("VuexAction err: ", res.error.type, res.error.message);
    });

    // Subscribes to the vuex mutations and stores the subscriptions in a variable
    const unsubscribeMutations = store.subscribe(async (mutation: any, state: any) =>
      service.handleSubscribeMutation(mutation, state, store)
    );

    // You may call unsubscribe to stop the subscription
    // unsubscribeActions();
    // unsubscribeMutations();
  };
}
